import AWS from 'aws-sdk/global'
import KMS from 'aws-sdk/clients/kms.js'

AWS.config.region = 'ap-northeast-1'
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'ap-northeast-1:63985611-aadb-4d6f-b653-2c4cbdd5bb94'
})

export function kmsDecrypt (params) {
  return new Promise((resolve, reject) => {
    const kmsClient = new KMS() // kmsTool
    kmsClient.decrypt(params, (err, data) => {
      if (err) reject(err)
      else {
        const { Plaintext } = data
        // console.log(Plaintext)
        resolve(Plaintext)
      }
    })
  })
}

export function kmsEncrypt (params) {
  const plaintext = {
    KeyId: 'arn:aws:kms:ap-northeast-1:580691962331:alias/ear-app-Encrypt',
    Plaintext: params
  }
  // console.log(Plaintext)
  return new Promise((resolve, reject) => {
    const kmsClient = new AWS.KMS() // kmsTool
    kmsClient.encrypt(plaintext, (err, data) => {
      if (err) reject(err)
      else {
        // console.log(data)
        const { CiphertextBlob } = data
        // console.log(`CiphertextBlob: ${CiphertextBlob}`)
        resolve(CiphertextBlob)
      }
    })
  })
}

export function base64ToArrayBuffer (base64) {
  // eslint-disable-next-line camelcase
  var binary_string = window.atob(base64)
  var len = binary_string.length
  var bytes = new Uint8Array(len)
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i)
  }
  return bytes.buffer
}



// WEBPACK FOOTER //
// ./src/utils/kmsＭethod.js